import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Transaction} from "@app/shared";
import {TxnErrorCode} from "@app/shared/txn-error-code/txn-error-code";


@Injectable()
export class TxnErrorCodeDataService {

  constructor(private http: HttpClient) {
  }

  getTxnErrorCode(refId: number, txnType: Transaction, managingOrgId?: number) {
    let url;
    if (managingOrgId >= 0) {
      url = `/solution/txn-error-code?refId=${refId}&transaction=${txnType}&orgId=${managingOrgId}`;
    } else {
      url = `/txn-error-code/txn-error-code?refId=${refId}&transaction=${txnType}`;
    }

    return this.http.get<TxnErrorCode[]>(url);
  }
}
